// extracted by mini-css-extract-plugin
export default {"userInfoText":"SelectedClientSection_userInfoText__VedsB"};